
import { StrategyBaseClass } from './strategy-base-class.js';


export class Instagram2Service extends StrategyBaseClass {
  constructor($translate) {
    super($translate);
  }

  getType() {
    return 9; // alcmeon.db.Sites.TYPE_INSTAGRAM_FACEBOOK
  }
  getTypeString() {
    return 'instagram2';
  }
  getAllTasksTypes() {
    return [37, 38, 42, 30, 43];
  }
  getPublicTaskTypes() {  // For favorites filtering
    return [30, 43];
  }
  getPrivateTaskTypes() {
    return [37, 38, 42];
  }
  getDefaultPrivateTaskType() {
    return 37;
  }
  getTaskTypeString(taskType) {
    let mapping = {
      30: 'instagram/comments',
      31: 'instagram/mentions',
      37: 'instagram/private',
      38: 'instagram/story-mention',
      42: 'instagram/story-reply',
      43: 'instagram/live-comments'
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType) {
    let mapping = {
      30: 'insta-comments',
      31: 'insta-mentions',
      37: 'insta-private',
      38: 'insta-story-mention',
      42: 'insta-story-reply',
      43: 'insta-live-comments'
    };
    return mapping[taskType];
  }

  canHaveSurveys() {
    return true;
  }

  taskTypeHasPublicationFilter(taskType) {
    return taskType === 30;
  }

  getEditorConfiguration(isPrivate) {
    return isPrivate ?
      {
        'pictureEnabled': true,
        'imageMimeTypes': 'image/jpeg, image/png, image/ico, image/bmp',
      }
      :
      {};
  }


  getQuickRepliesElementsConfig() {
    return {
      maxAnswerNb: 11,
      answerLabelMaxLength: 20,
      hasDescription: false,
      canHaveUserVariableInRootQuestion: false,
      hasPhoneEmailAnswerType: false,
      hasUrlAnswerType: false,
      hasTargetAppId: true,
      boxesCanBeTested: false,
      hasPersistentMenu: false,
      hasWelcomeMessage: false,
      imageMimeTypes: 'image/jpeg, image/png, image/ico, image/bmp',
      editorConfiguration: {
        fileEnabled: false,
        hasImageControl: false
      },
      sendTextAfterButtonChoice: false,
      canSendVideo: true
    };
  }

  static Instagram2Factory($translate) {
    return new Instagram2Service($translate);
  }

  mustCheckIfMessageDeleted(isPrivate) {
    // Check if message is deleted if it is public
    return !isPrivate;
  }

  getTaskTypesNotToTranslate() {
    // Do not show the label for instagram story-mention or story-reply
    return ['instagram-story-mention', 'instagram-story-reply'];
  }
}
Instagram2Service.Instagram2Factory.$inject = ['$translate'];
